import React from "react";

export function BellAlertIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5023 17.3609C18.5497 17.3609 19.3998 16.5135 19.4031 15.4661V15.4661V15.4661C19.4024 14.9331 19.1897 14.4224 18.8118 14.0465L17.5523 12.786V9.04141C17.552 7.56957 16.9668 6.15819 15.9254 5.1181C14.884 4.07801 13.4718 3.49451 12 3.4961V3.4961C8.93842 3.49776 6.45724 5.97983 6.45669 9.04141V12.783L5.19717 14.0435C4.81904 14.4192 4.60596 14.93 4.60492 15.4631V15.4631V15.4631C4.60823 16.5105 5.45827 17.3579 6.50571 17.3579L17.5023 17.3609Z"
        stroke="#AD4E00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5204 20.5041H13.4786"
        stroke="#AD4E00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VolumeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M15 10V14" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 8V16" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.875 8.62486H3.5C2.948 8.62486 2.5 9.07286 2.5 9.62486V14.3749C2.5 14.9269 2.948 15.3749 3.5 15.3749H5.875L9.854 18.7459C10.504 19.2969 11.5 18.8349 11.5 17.9829V6.01686C11.5 5.16486 10.503 4.70286 9.854 5.25386L5.875 8.62486Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckTickIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
      <path
        d="M8.5 0.5L3.49896 5.5L0.5 2.5"
        stroke="#148DFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
